import styled from "styled-components"

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    font-family: Montserrat !important;
    /* .border-div{
        border-right: 10px solid #444;
    } */
`